"use client";

import { useMemo } from "react";
import {
  ALL_VIEW_ID,
  type RecordSeededView,
  type RecordTotal,
  type RecordView,
} from "../types";

export function useAllViews(
  object: {
    label: string;
    allViewName?: string;
    seededViews: RecordSeededView[];
  },
  views: RecordView[],
  allCount: RecordTotal | undefined,
): RecordView[] {
  return useMemo<RecordView[]>(
    () => [
      {
        id: ALL_VIEW_ID,
        name: object.allViewName ?? `All ${object.label.toLowerCase()}`,
        scope: "shared",
        filters: [],
        isOwner: false,
        isDefault: false,
        count: allCount,
      },
      ...object.seededViews.map((view) => ({
        ...view,
        scope: "shared" as const,
        isOwner: false,
        isDefault: false,
        isSeeded: true,
      })),
      ...views,
    ],
    [views, object.label, object.allViewName, object.seededViews, allCount],
  );
}
